import { NgModule } from '@angular/core';
import { EinvoiceViewerComponent } from './components/einvoice-viewer/einvoice-viewer.component';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { EinvoiceDocumentComponent } from './components/einvoice-document/einvoice-document.component';
import { FieldComponent } from './components/einvoice-document/field/field.component';
import { EinvoiceModelTreeComponent } from './components/model-tree/model-tree.component';
import { EinvoicePdfViewComponent } from './components/pdf-view/pdf-view.component';
import { EinvoiceXmlViewComponent } from './components/xml-view/xml-view.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TechnicalDetailsDialogComponent } from './shared/modals/technical-details-dialog/technical-details-dialog.component';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { FileDragNDropDirective } from './directives/file-drag-n-drop.directive';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

@NgModule({
  declarations: [
    EinvoiceViewerComponent,
    DropzoneComponent,
    EinvoiceDocumentComponent,
    FieldComponent,
    EinvoiceModelTreeComponent,
    EinvoicePdfViewComponent,
    EinvoiceXmlViewComponent,
    TechnicalDetailsDialogComponent,
    FileDragNDropDirective,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatTableModule,
    MatSnackBarModule,
    PdfJsViewerModule
  ],
  exports: [
    EinvoiceViewerComponent,
    DropzoneComponent,
    EinvoiceDocumentComponent,
    FieldComponent,
    EinvoiceModelTreeComponent,
    EinvoicePdfViewComponent,
    EinvoiceXmlViewComponent,
  ],
  providers: [
    DecimalPipe,
    DatePipe
  ],
})
export class EinvoiceViewerModule { }

